import { useSelector } from "react-redux";
import Loading from "../sections/Loading";

const LoadingProvider = ({children=''}) => {
    const loading = useSelector(s=>s.loading);
    return (<>
        {children}
        {loading?<Loading/>:null}
    </>)
}
export default LoadingProvider;